import { render, staticRenderFns } from "./CompetitionHeroBlock.vue?vue&type=template&id=4e81fa62&"
import script from "./CompetitionHeroBlock.vue?vue&type=script&lang=js&"
export * from "./CompetitionHeroBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports